export const TEAM = 'TEAM';
export const CONFIRMATION = 'CONFIRMATION';
